import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import {
  createContractCooperationTypes,
  updateContractCooperationType,
} from 'modules/settings/api';

export const useMutationContractCooperationTypes = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const { mutateAsync: mutateCreate, isLoading: createMutationLoader } = useMutation(
    createContractCooperationTypes,
    {
      onSuccess: () => {
        successToast();
      },
      onError: () => errorToast(),
      onSettled: () => queryClient.refetchQueries(QUERY_KEYS.CONTRACT_COOPERATION_TYPES),
    },
  );

  const { mutateAsync: mutateUpdate, isLoading: updateMutationLoader } = useMutation(
    updateContractCooperationType,
    {
      onSuccess: () => {
        successToast();
      },
      onError: () => errorToast(),
      onSettled: () => queryClient.refetchQueries(QUERY_KEYS.CONTRACT_COOPERATION_TYPES),
    },
  );

  return { mutateCreate, mutateUpdate, isLoading: createMutationLoader || updateMutationLoader };
};
